import React from "react"
import { useSelector } from "react-redux"

import { VIEW, EDIT } from "const"
import { mtModulesRoute } from "client/parts/routes"
import { StoreType } from "client/store"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"

import List from "./list"
import View from "./view"
import Edit from "./edit"

const MtModule = () => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    return userData.accountId === 1
        ? (
            <Switch>
                <Route
                    exact
                    path={mtModulesRoute}
                    component={List}
                />
                <Route
                    path={`${mtModulesRoute}/${VIEW}/:moduleId`}
                    component={View}
                />
                <Route
                    path={`${mtModulesRoute}/${EDIT}/:moduleId`}
                    component={Edit}
                />
            </Switch>
        )
        : <AccessDenied />
}
export default MtModule
